import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

// Food Trucks
export const getFoodTrucks = () => axios.get(`${API_URL}/food-trucks`);
export const getFoodTruck = (id) => axios.get(`${API_URL}/food-trucks/${id}`);
export const createFoodTruck = (data) => axios.post(`${API_URL}/food-trucks`, data);
export const updateFoodTruck = (id, data) => axios.put(`${API_URL}/food-trucks/${id}`, data);
export const deleteFoodTruck = (id) => axios.delete(`${API_URL}/food-trucks/${id}`);

// Events
export const getEvents = () => axios.get(`${API_URL}/events`);
export const getEvent = (id) => axios.get(`${API_URL}/events/${id}`);
export const createEvent = (data) => axios.post(`${API_URL}/events`, data);
export const updateEvent = (id, data) => axios.put(`${API_URL}/events/${id}`, data);
export const deleteEvent = (id) => axios.delete(`${API_URL}/events/${id}`);
export const addParticipant = (eventId, ftId) => axios.post(`${API_URL}/events/${eventId}/participants/${ftId}`);
export const removeParticipant = (eventId, ftId) => axios.delete(`${API_URL}/events/${eventId}/participants/${ftId}`);
export const voteOnEvent = (eventId, vote, staffEvenement = null) => axios.post(`${API_URL}/events/${eventId}/vote`, { vote, staff_evenement: staffEvenement });
export const getEventVotes = (eventId) => axios.get(`${API_URL}/events/${eventId}/votes`);
export const removeVote = (eventId) => axios.delete(`${API_URL}/events/${eventId}/vote`);
export const payEvent = (eventId, ftId) => axios.post(`${API_URL}/events/${eventId}/pay/${ftId}`);
export const submitBilanPrestation = (eventId, ftId, data) => axios.post(`${API_URL}/events/${eventId}/bilan/${ftId}`, data);
export const getBilanPrestation = (eventId, ftId) => axios.get(`${API_URL}/events/${eventId}/bilan/${ftId}`);
export const getAllBilans = () => axios.get(`${API_URL}/admin/bilans`);

// Cotisations
export const getCotisations = () => axios.get(`${API_URL}/cotisations`);
export const getCotisationsByFoodTruck = (ftId) => axios.get(`${API_URL}/cotisations/food-truck/${ftId}`);
export const payCotisation = (id) => axios.post(`${API_URL}/cotisations/${id}/pay`);
export const getMyCotisations = () => axios.get(`${API_URL}/cotisations/me`);

// Achats Bureau
export const getAchatsBureau = () => axios.get(`${API_URL}/achats-bureau`);
export const createAchatBureau = (data) => axios.post(`${API_URL}/achats-bureau`, data);
export const payAchatBureau = (achatId, ftId) => axios.post(`${API_URL}/achats-bureau/${achatId}/pay/${ftId}`);
export const getMyAchatsBureau = () => axios.get(`${API_URL}/achats-bureau/me`);
export const createAchatBureauCheckout = (achatId) => axios.post(`${API_URL}/achats-bureau/checkout?achat_id=${achatId}`);

// Payments
export const getPayments = () => axios.get(`${API_URL}/payments`);
export const getPaymentsByFoodTruck = (ftId) => axios.get(`${API_URL}/payments/food-truck/${ftId}`);

// Dashboard
export const getAdminDashboard = () => axios.get(`${API_URL}/dashboard/admin`);
export const getMembreDashboard = (ftId) => axios.get(`${API_URL}/dashboard/membre/${ftId}`);

// Users
export const getUsers = () => axios.get(`${API_URL}/users`);
export const linkUserToFoodTruck = (userId, ftId) => axios.put(`${API_URL}/users/${userId}/link-food-truck/${ftId}`);
export const updateUserRole = (userId, role) => axios.put(`${API_URL}/users/${userId}/role/${role}`);
export const deleteUser = (userId) => axios.delete(`${API_URL}/users/${userId}`);
export const adminResetUserPassword = (userId, newPassword) => axios.post(`${API_URL}/users/${userId}/reset-password`, { new_password: newPassword });
export const changePassword = (currentPassword, newPassword) => axios.post(`${API_URL}/auth/change-password`, { current_password: currentPassword, new_password: newPassword });
export const forgotPassword = (email) => axios.post(`${API_URL}/auth/forgot-password`, { email });
export const resetPassword = (token, newPassword) => axios.post(`${API_URL}/auth/reset-password`, { token, new_password: newPassword });

// KPIs
export const getKPIs = () => axios.get(`${API_URL}/kpis`);

// Documents
export const addDocument = (ftId, data) => axios.post(`${API_URL}/food-trucks/${ftId}/documents`, data);
export const deleteDocument = (ftId, docId) => axios.delete(`${API_URL}/food-trucks/${ftId}/documents/${docId}`);
export const getDocuments = (ftId) => axios.get(`${API_URL}/food-trucks/${ftId}/documents`);

// File Upload
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// File Upload Public (for registration without auth)
export const uploadFilePublic = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/upload-public`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getFileUrl = (fileId) => `${API_URL}/files/${fileId}`;

// Ouvre un fichier déposé dans un nouvel onglet. Les documents privés ne sont
// plus servis sur leur URL brute : on demande d'abord au serveur une URL
// signée, valable 15 minutes. L'onglet est ouvert avant l'appel, sinon le
// navigateur le bloque comme pop-up. Les URL déjà signées et les autres liens
// sont ouverts tels quels.
const FICHIER_PRIVE = /\/api\/files\/([0-9A-Za-z-]+)(?:\?|$)/;
const JUSTIFICATIF = /\/uploads\/justificatifs\/([^/?]+)/;
export const ouvrirFichier = async (url) => {
  if (!url) return;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const absolue = (u) => (/^https?:/.test(u) ? u : `${base}${u}`);
  const fichier = url.match(FICHIER_PRIVE);
  const justificatif = !fichier && url.match(JUSTIFICATIF);
  if ((!fichier && !justificatif) || url.includes("sig=")) {
    window.open(absolue(url), "_blank", "noopener,noreferrer");
    return;
  }
  const onglet = window.open("", "_blank");
  try {
    const res = fichier
      ? await axios.get(`${API_URL}/files/${fichier[1]}/lien`)
      : await axios.get(`${API_URL}/justificatifs-achat/lien`, { params: { fichier: justificatif[1] } });
    if (onglet) {
      onglet.opener = null;
      onglet.location.href = absolue(res.data.url);
    } else {
      window.location.href = absolue(res.data.url);
    }
  } catch (e) {
    if (onglet) onglet.close();
    throw e;
  }
};

// Settings
export const getSettings = () => axios.get(`${API_URL}/settings`);
export const updateSettings = (data) => axios.put(`${API_URL}/settings`, data);
export const getStripeSettings = () => axios.get(`${API_URL}/settings/stripe`);
export const updateStripeKey = (stripeKey) => axios.put(`${API_URL}/settings/stripe`, { stripe_key: stripeKey });

// Admin Validations
export const getPendingValidations = () => axios.get(`${API_URL}/admin/pending-validations`);
export const validateFoodTruck = (ftId) => axios.post(`${API_URL}/admin/validate-food-truck/${ftId}`);
export const rejectFoodTruck = (ftId, reason = "") => axios.post(`${API_URL}/admin/reject-food-truck/${ftId}?reason=${encodeURIComponent(reason)}`);
export const sendRelance = (ftId) => axios.post(`${API_URL}/admin/send-relance/${ftId}`);
export const resetRelances = (ftId) => axios.post(`${API_URL}/admin/reset-relances/${ftId}`);

// Access Status
export const getAccessStatus = () => axios.get(`${API_URL}/auth/access-status`);

// PDF/Invoices
export const getCotisationInvoiceUrl = (cotisationId) => `${API_URL}/invoices/cotisation/${cotisationId}`;
export const getUserCotisationInvoiceUrl = (userId, annee) => `${API_URL}/invoices/cotisation/user/${userId}/${annee}`;
export const getEventInvoiceUrl = (eventId, ftId) => `${API_URL}/invoices/event/${eventId}/${ftId}`;
export const getMonthlyReportUrl = (year, month) => `${API_URL}/reports/monthly/${year}/${month}`;

// My Cotisation Status (for members)
export const getMyCotisationStatus = () => axios.get(`${API_URL}/cotisation/my-status`);

// Excel Exports
export const getExportCotisationsUrl = () => `${API_URL}/export/cotisations`;
export const getExportAdherentsUrl = () => `${API_URL}/export/adherents`;
export const getExportPaiementsUrl = () => `${API_URL}/export/paiements`;
export const getExportAchatsBureauUrl = () => `${API_URL}/export/achats-bureau`;
export const getExportSyntheseFinanciereUrl = () => `${API_URL}/export/synthese-financiere`;

// Charts Data
export const getRevenueMonthlyChart = () => axios.get(`${API_URL}/charts/revenue-monthly`);
export const getFoodTrucksStatusChart = () => axios.get(`${API_URL}/charts/food-trucks-status`);
export const getPaymentsStatusChart = () => axios.get(`${API_URL}/charts/payments-status`);
export const getEventsByMonthChart = () => axios.get(`${API_URL}/charts/events-by-month`);

// Stripe Payments
export const getPaymentPackages = () => axios.get(`${API_URL}/payment/packages`);
export const createPaymentCheckout = (data) => axios.post(`${API_URL}/payment/checkout`, data);
export const getPaymentStatus = (sessionId) => axios.get(`${API_URL}/payment/status/${sessionId}`);

// Admin Scheduler
export const runDailyChecks = () => axios.post(`${API_URL}/admin/run-daily-checks`);
export const getExpiringDocuments = (days = 30) => axios.get(`${API_URL}/admin/expiring-documents?days=${days}`);
export const getUnpaidCotisationsList = () => axios.get(`${API_URL}/admin/unpaid-cotisations`);
export const sendDocumentReminders = () => axios.post(`${API_URL}/admin/send-document-reminders`);
export const sendPaymentReminders = () => axios.post(`${API_URL}/admin/send-payment-reminders`);

// Specialties
export const getSpecialties = () => axios.get(`${API_URL}/specialites`);

// Gallery
export const getGalleryPhotos = () => axios.get(`${API_URL}/gallery`);

// Invoices
export const generateInvoice = (paymentId, sendEmail = true) => axios.post(`${API_URL}/invoices/generate`, { payment_id: paymentId, send_email: sendEmail });
export const downloadInvoice = (paymentId) => axios.get(`${API_URL}/invoices/${paymentId}/download`, { responseType: 'blob' });
export const getInvoicesByFoodTruck = (ftId) => axios.get(`${API_URL}/invoices/food-truck/${ftId}`);

// Event proposals
export const proposeEvent = (data) => axios.post(`${API_URL}/events/propose`, data);
export const getPendingEvents = () => axios.get(`${API_URL}/events/pending`);
export const validateEvent = (eventId) => axios.post(`${API_URL}/events/${eventId}/validate`);
export const refuseEvent = (eventId, reason) => axios.post(`${API_URL}/events/${eventId}/refuse`, { reason });

// Bulk Delete Operations
export const bulkDeleteEvents = (ids) => axios.delete(`${API_URL}/events/bulk`, { data: { ids } });
export const bulkDeleteFoodTrucks = (ids) => axios.delete(`${API_URL}/food-trucks/bulk`, { data: { ids } });
export const bulkDeleteCotisations = (ids) => axios.delete(`${API_URL}/cotisations/bulk`, { data: { ids } });
export const bulkDeletePayments = (ids) => axios.delete(`${API_URL}/payments/bulk`, { data: { ids } });
export const bulkDeleteAchatsBureau = (ids) => axios.delete(`${API_URL}/achats-bureau/bulk`, { data: { ids } });
export const bulkDeleteUsers = (ids) => axios.delete(`${API_URL}/users/bulk`, { data: { ids } });

// Messages
export const sendMessage = (data) => axios.post(`${API_URL}/messages`, data);
export const getMessages = () => axios.get(`${API_URL}/messages`);
export const getConversations = () => axios.get(`${API_URL}/messages/conversations`);
export const getConversationMessages = (participantId) => axios.get(`${API_URL}/messages/conversation/${participantId}`);
export const markMessageRead = (messageId) => axios.put(`${API_URL}/messages/${messageId}/read`);
export const getUnreadCount = () => axios.get(`${API_URL}/messages/unread-count`);

// Admin Data Management
export const purgeAllData = () => axios.delete(`${API_URL}/admin/purge-all-data`);
export const purgeAdherentsData = () => axios.delete(`${API_URL}/admin/purge-adherents-data`);
export const purgeTotalData = () => axios.delete(`${API_URL}/admin/purge-total`);
export const changeAdminEmail = (newEmail) => axios.post(`${API_URL}/admin/change-email`, { new_email: newEmail });

// CRM
export const getCRMClients = () => axios.get(`${API_URL}/crm/clients`);
export const getCRMClient = (id) => axios.get(`${API_URL}/crm/clients/${id}`);
export const createCRMClient = (data) => axios.post(`${API_URL}/crm/clients`, data);
export const updateCRMClient = (id, data) => axios.put(`${API_URL}/crm/clients/${id}`, data);
export const deleteCRMClient = (id) => axios.delete(`${API_URL}/crm/clients/${id}`);
export const addCRMContact = (clientId, data) => axios.post(`${API_URL}/crm/clients/${clientId}/contacts`, data);
export const deleteCRMContact = (clientId, contactId) => axios.delete(`${API_URL}/crm/clients/${clientId}/contacts/${contactId}`);
export const getCRMStats = () => axios.get(`${API_URL}/crm/stats`);
export const checkEmailLeads = () => axios.post(`${API_URL}/crm/check-emails`);

// Quotes/Devis
export const getQuotes = () => axios.get(`${API_URL}/quotes`);
export const getPendingQuotes = () => axios.get(`${API_URL}/quotes/pending`);
export const getQuote = (id) => axios.get(`${API_URL}/quotes/${id}`);
export const generateQuote = (data) => axios.post(`${API_URL}/quotes/generate`, data);
export const validateQuote = (id) => axios.post(`${API_URL}/quotes/${id}/validate`);
export const rejectQuote = (id) => axios.post(`${API_URL}/quotes/${id}/reject`);
export const sendQuote = (id) => axios.post(`${API_URL}/quotes/${id}/send`);
export const updateQuoteStatus = (id, status) => axios.put(`${API_URL}/quotes/${id}/status?status=${status}`);
export const downloadQuotePdf = (id) => axios.get(`${API_URL}/quotes/${id}/download`, { responseType: 'blob' });

// HEC Planning
export const getHECPlannings = () => axios.get(`${API_URL}/hec/plannings`);
export const getHECPlanning = (id) => axios.get(`${API_URL}/hec/plannings/${id}`);
export const createHECPlanning = (data) => axios.post(`${API_URL}/hec/plannings`, data);
export const updateHECPlanning = (id, data) => axios.put(`${API_URL}/hec/plannings/${id}`, data);
export const deleteHECPlanning = (id) => axios.delete(`${API_URL}/hec/plannings/${id}`);
export const seedHECFromExcel = () => axios.post(`${API_URL}/hec/plannings/seed-from-excel`);

// Notifications
export const getNotifications = () => axios.get(`${API_URL}/notifications`);
export const getNotificationsUnreadCount = () => axios.get(`${API_URL}/notifications/unread-count`);
export const markNotificationRead = (id) => axios.put(`${API_URL}/notifications/${id}/read`);
export const markAllNotificationsRead = () => axios.put(`${API_URL}/notifications/mark-all-read`);
export const deleteNotification = (id) => axios.delete(`${API_URL}/notifications/${id}`);

// Hygiene HACCP Module
export const getHygieneRules = () => axios.get(`${API_URL}/hygiene/rules`);
export const createHygieneRule = (data) => axios.post(`${API_URL}/hygiene/rules`, data);
export const updateHygieneRule = (id, data) => axios.put(`${API_URL}/hygiene/rules/${id}`, data);
export const deleteHygieneRule = (id) => axios.delete(`${API_URL}/hygiene/rules/${id}`);

export const getHygieneReceptions = (days = 90) => axios.get(`${API_URL}/hygiene/receptions?days=${days}`);
export const createHygieneReception = (data) => axios.post(`${API_URL}/hygiene/receptions`, data);
export const deleteHygieneReception = (id) => axios.delete(`${API_URL}/hygiene/receptions/${id}`);

export const getHygieneTemperatures = (days = 7) => axios.get(`${API_URL}/hygiene/temperatures?days=${days}`);
export const createHygieneTemperature = (data) => axios.post(`${API_URL}/hygiene/temperatures`, data);
export const getHygieneEquipements = () => axios.get(`${API_URL}/hygiene/temperatures/equipements`);

export const getHygieneCookingLogs = (days = 30) => axios.get(`${API_URL}/hygiene/temperatures/cooking?days=${days}`);
export const createHygieneCookingLog = (data) => axios.post(`${API_URL}/hygiene/temperatures/cooking`, data);

export const getHygieneCleaningTasks = () => axios.get(`${API_URL}/hygiene/cleaning/tasks`);
export const createHygieneCleaningTask = (data) => axios.post(`${API_URL}/hygiene/cleaning/tasks`, data);
export const updateHygieneCleaningTask = (id, data) => axios.put(`${API_URL}/hygiene/cleaning/tasks/${id}`, data);
export const deleteHygieneCleaningTask = (id) => axios.delete(`${API_URL}/hygiene/cleaning/tasks/${id}`);
export const getHygieneCleaningLogs = (days = 7) => axios.get(`${API_URL}/hygiene/cleaning/logs?days=${days}`);
export const createHygieneCleaningLog = (data) => axios.post(`${API_URL}/hygiene/cleaning/logs`, data);
export const getHygieneTodayCleaning = () => axios.get(`${API_URL}/hygiene/cleaning/today`);

export const getHygieneProduction = (days = 30) => axios.get(`${API_URL}/hygiene/production?days=${days}`);
export const createHygieneProduction = (data) => axios.post(`${API_URL}/hygiene/production`, data);
export const deleteHygieneProduction = (id) => axios.delete(`${API_URL}/hygiene/production/${id}`);

export const getHygienePMS = () => axios.get(`${API_URL}/hygiene/pms`);
export const uploadHygienePMS = (data) => axios.post(`${API_URL}/hygiene/pms`, data);

export const exportHygienePDF = (dateDebut, dateFin) => 
  axios.get(`${API_URL}/hygiene/export/pdf?date_debut=${dateDebut}&date_fin=${dateFin}`, { responseType: 'blob' });


// Fiches camions et dossiers de reponse
export const getFichesCamions = () => axios.get(`${API_URL}/fiches-camions`);
export const enregistrerFicheCamion = (id, data) =>
  axios.put(`${API_URL}/fiches-camions/${id}`, data);
export const enregistrerPhotosCamion = (id, data) =>
  axios.put(`${API_URL}/fiches-camions/${id}/photos`, data);
export const getCarteProposee = (id) =>
  axios.get(`${API_URL}/fiches-camions/${id}/carte-proposee`);
export const getCamionsDossier = () => axios.get(`${API_URL}/dossiers/camions`);
export const verifierDossier = (data) =>
  axios.post(`${API_URL}/dossiers/verifier`, data);
export const historiqueDossiers = () =>
  axios.get(`${API_URL}/dossiers/historique`);
